import React, {
    useCallback
} from 'react';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';
import { EHHO4PropertyDetailsComponent } from 'e1p-capability-policyjob-react';


function PropertyPage(props) {
    const { wizardData: rewriteVM } = props;

    const onNext = useCallback(
        () => rewriteVM,
        [rewriteVM]
    );

    return (
        <WizardPage
            onNext={onNext}
            shouldLink
        >
            <EHHO4PropertyDetailsComponent
                onValidate={() => {}}
                transactionVM={rewriteVM}
                updateWizardData={() => {}}
                isPageSubmitted={false}
                setShouldSkipAdditionalInfo={() => {}}
                isSavingCurrentPageChanges={false}
                isSkipping={false}
                isSavingEndorsement={false}
                viewOnly
            />
        </WizardPage>
    );
}

PropertyPage.propTypes = wizardProps;
export default PropertyPage;
